import React, { useEffect, useState } from 'react'
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material'
import { type DisbursementInstructionDetails } from '../../../../api-schema-types/payments/DisbursementInstructionDomainDtos'
import { useCreateDisbursementBatchMutation } from '../../../../api-services/payments/paymentsApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'

interface CreateBatchProps {
  pendingInstructions: DisbursementInstructionDetails[]
}

const CreateDisbursementBatch: React.FC<CreateBatchProps> = ({ pendingInstructions }: CreateBatchProps) => {
  const dispatch = useAppDispatch()
  const [currencyCode, setCurrencyCode] = useState<string>('')
  const [schedule, setSchedule] = useState<string>('')

  const pendingCurrencyCodes: string[] = []
  const set = new Set(pendingInstructions.map((i) => i.currencyCode))
  set.forEach((c) => pendingCurrencyCodes.push(c))

  const pendingSchedules: string[] = []
  const scheduleSet = new Set(pendingInstructions.map((i) => i.schedule))
  scheduleSet.forEach((c) => pendingSchedules.push(c))

  const [apiCreateBatchTrigger, apiCreateBatchResult] = useCreateDisbursementBatchMutation()

  const handleCurrencyChange = (evt: SelectChangeEvent<string>): void => { setCurrencyCode(evt.target.value) }
  const handleScheduleChange = (evt: SelectChangeEvent<string>): void => { setSchedule(evt.target.value) }

  const handleFormSubmit = async (): Promise<void> => {
    await apiCreateBatchTrigger({ currencyCode, schedule })
  }

  useEffect(() => {
    if (apiCreateBatchResult.isSuccess) {
      dispatch(setNotification({ open: true, severity: 'success', message: `Disbursement batch ${apiCreateBatchResult.data.disbursementBatchId} created.` }))
      setCurrencyCode('')
    }

    if (apiCreateBatchResult.isError) {
      dispatch(setNotification({
        open: true,
        severity: 'error',
        message: RtkQueryHelper.mapResponseError(apiCreateBatchResult.error)
      }))
    }
  }, [apiCreateBatchResult.isSuccess, apiCreateBatchResult.isError])

  return (
    <>
      <Grid container spacing={2} >
        <Grid item md={2}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel>Currency</InputLabel>
            <Select label={'Currency'}
                    disabled={pendingInstructions.length === 0}
                    onChange={handleCurrencyChange}
                    value={currencyCode}>
              {
                pendingCurrencyCodes.map((c) =>
                  <MenuItem key={c} value={c}>{c}</MenuItem>
                )
              }
            </Select>
          </FormControl>
        </Grid>

        <Grid item md={2}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel>Schedule</InputLabel>
            <Select label={'Currency'}
                    disabled={pendingSchedules.length === 0}
                    onChange={handleScheduleChange}
                    value={schedule}>
              {
                pendingSchedules.map((c) =>
                  <MenuItem key={c} value={c}>{c}</MenuItem>
                )
              }
            </Select>
          </FormControl>
        </Grid>

        <Grid item md={4} justifyContent={'flex-end'}>
          <Button type={'button'} variant={'contained'}
                  disabled={pendingInstructions.length === 0}
                  onClick={handleFormSubmit}>
            Create Batch
          </Button>

        </Grid>
      </Grid>
    </>
  )
}

export default CreateDisbursementBatch
